<template>
  <li 
  class="square"
  :class="{ isOpen : square.isOpen, transition: transition }"
  :style="{ 
    width: baseSize / matrix.length + 'px', 
    height: baseSize / matrix.length + 'px', 
    color: square.isOpen ? fontColor : '#222'
  }"
  @click.left="openSquare"
  @click.right="flagBomb"
  >
  {{ !square.isOpen && square.isFlag ? emoji.flag.image : '' }}
  {{ square.isOpen && square.isMine ? emoji.bomb.image : '' }}
  {{ square.isOpen ? square.value === 0 ? '' : square.value : ''}}
  </li>
</template>
<script>
import { mapState } from 'vuex'
import { baseSize, emoji } from '../const'
import { calcRoundBlank } from '../utils'
import { gameOver } from '../utils/play'

export default {
  name: 'Square',
  props: ['matrix','squareData'],
  data () {
    return {
      baseSize,
      emoji,
      square: null,
      transition: false
    }
  },
  watch: {
    squareData : {
      handler (squareData) {
        this.square = squareData
      },
      immediate: true
    },
    'squareData.isOpen': {
      handler (isOpen) {
        if(isOpen) this.$store.dispatch('flipTotalCount')
      }
    },
    '$store.state.gameOver': {
      handler (gameOver) {
        if( gameOver ) this.square.isOpen = true
      }
    },
    '$store.state.level' : {
      handler () {
        this.resetTransition()
      }
    },
    '$store.state.isPlaying' : {
      handler () {
        this.resetTransition()
      }
    }
  },
  computed: {
    ...mapState(['firstClickSquare']),
    isPlaying () {
      return this.$store.state.isPlaying
    },
    fontColor () {
      const { value } = this.squareData
      if( value === 1) {
        return '#53aa4c'
      }
      else if ( value === 2) {
        return '#7cbcd9'
      } 
      else if (value === 3) {
        return '#bd3887'
      }
      else if (value >= 4) {
        return '#bd002d'
      }
      else {
        return '#222'
      }
    }
  },
  methods: {
    openSquare () {
      // 游戏开始才能点击
      if( !this.isPlaying ) return
      // 旗子不能点击
      if( this.square.isFlag ) return
      // 每局第一次点击不能踩雷,保证游玩体验
      if( !this.firstClickSquare ) {
        this.$store.dispatch('setFirstClickSquare', this.square)
        this.$emit('initMatrixAtFirstClick')
      } 
      // 踩雷了游戏结束
      if( this.square.isMine ) {
        // setGameOver
        gameOver(this.matrix)
        return
      }
      // 如果翻开的有数值则只翻开当前的square
      if(!this.square.isMine && !this.square.isFlag ) {
        //
        this.square.isOpen = true
        //
        if( this.square.value === 0 ) calcRoundBlank(this.matrix, this.square)
      }
      
    },
    // 用旗子进行标记炸弹
    flagBomb (event) {
      event.preventDefault();
      if( !this.square.isOpen ) {
        this.square.isFlag = !this.square.isFlag
        // 将当前区块保存起来做输赢判定
        this.$store.dispatch('setFlag', this.square)
      }
    },
    // 为了避免区块在做动效时候产生某些边框消失的问题；
    resetTransition() {
      this.transition = false
      setTimeout(()=>{
        this.transition = true
      },300)
    }
  }
}
</script>

<style lang="scss" scoped>
$color: rgb(160, 192, 226);
$borderColor: darken($color, 10%);

.square {
  display: flex;
  justify-content: center;
  align-items: center;
  border-right: 1px solid $borderColor;
  border-bottom: 1px solid $borderColor;
  background-color: $color;
  font-weight: 600;
  transform: translateZ(0);
  box-sizing: border-box;

  &.transition {
    transition: all .4s ease;
  }
  
  &:last-child {
    border-right: none;
  }

  &.isOpen {
    background-color: rgb(233, 233, 233);
  }
}
</style>